// extracted by mini-css-extract-plugin
export default {"tokenText":"HeaderIssueType-module__tokenText__XdGqggY","smallToken":"HeaderIssueType-module__smallToken__uPuZJl2","IssueTypeToken":"HeaderIssueType-module__IssueTypeToken__bbC2nM4"};